var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoubleLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6399 5.23005C11.5389 5.14585 11.4222 5.08241 11.2966 5.04337C11.171 5.00432 11.0389 4.99044 10.908 5.00251C10.777 5.01459 10.6497 5.05239 10.5333 5.11374C10.417 5.17509 10.3139 5.25879 10.2299 5.36005L5.22993 11.3601C5.08285 11.539 5.00244 11.7634 5.00244 11.9951C5.00244 12.2267 5.08285 12.4511 5.22993 12.6301L10.0599 18.6301C10.154 18.7461 10.273 18.8395 10.4079 18.9036C10.5429 18.9676 10.6905 19.0006 10.8399 19.0001C11.0292 19.0007 11.2147 18.9476 11.375 18.847C11.5353 18.7464 11.6637 18.6024 11.7454 18.4317C11.8271 18.261 11.8586 18.0706 11.8364 17.8827C11.8142 17.6948 11.7391 17.517 11.6199 17.3701L7.28993 12.0001L11.7699 6.63005C11.9369 6.42655 12.0169 6.16544 11.9925 5.90335C11.9682 5.64126 11.8415 5.39933 11.6399 5.23005Z",
    fill: "#FC5719"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2899 12L18.7699 6.63002C18.9397 6.4258 19.0213 6.16252 18.997 5.8981C18.9726 5.63367 18.8441 5.38976 18.6399 5.22002C18.4357 5.05028 18.1724 4.96862 17.908 4.993C17.6436 5.01738 17.3997 5.1458 17.2299 5.35002L12.2299 11.35C12.0828 11.529 12.0024 11.7534 12.0024 11.985C12.0024 12.2166 12.0828 12.4411 12.2299 12.62L17.0599 18.62C17.154 18.736 17.273 18.8295 17.4079 18.8935C17.5429 18.9576 17.6905 18.9905 17.8399 18.99C18.0292 18.9907 18.2147 18.9376 18.375 18.837C18.5353 18.7364 18.6637 18.5924 18.7454 18.4217C18.8271 18.251 18.8586 18.0606 18.8364 17.8727C18.8142 17.6848 18.7392 17.507 18.6199 17.36L14.2899 12Z",
    fill: "#FC5719"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeftArrow);
export default __webpack_public_path__ + "static/media/double-left-arrow.caa2777cc206d13a58670744d4bcc2d7.svg";
export { ForwardRef as ReactComponent };